$(document).ready(function () {

    $('select[name="objetDemande"]').each(function () {
        chargeFormulaireContact();
        $(this).on("change", function () {
            chargeFormulaireContact();
        })
    })

    function chargeFormulaireContact() {
        const value = $('select[name="objetDemande"]').val();
        const error_deja_client = $('#error_deja_client').val();
        if (value == "4") {
            $('#bloc-texte-reclamation-deja-client').hide();
            $('.contact_opportunite_form_toHide').hide();
            if (error_deja_client === "true") {
                $('#bloc-texte-reclamation-deja-client').show();
                $('.bloc-boutons-connexion').hide();
            }
        }
        $('div .objet-formulaire-bloc-texte').hide();
        $('#bloc-objet-formulaire-' + value).show();
    }

    $("#btn-client-reclamation-form").on("click", function () {
        $(this).addClass('btnConnexionAvantMire');
        $("#btn-pas-client-reclamation-form").removeClass('btnConnexionAvantMire');
        $('#bloc-texte-reclamation-deja-client').show();
        $('.contact_opportunite_form_toHide').hide();
    })

    $("#btn-pas-client-reclamation-form").on("click", function () {
        $(this).addClass('btnConnexionAvantMire');
        $("#btn-client-reclamation-form").removeClass('btnConnexionAvantMire');
        $('#bloc-texte-reclamation-deja-client').hide();
        $('.contact_opportunite_form_toHide').show();
    })
});
